import produce from 'immer';

// TYPES
import { Types, ConsultarCondutor } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultarCondutor = {
	status: 0,
	data: null,
};

export default function consultarCondutorReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarCondutor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CONDUTOR_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTAR_CONDUTOR_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.CONSULTAR_CONDUTOR_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.status = 400;
				break;
			}
			case Types.CONSULTAR_CONDUTOR_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
